<ziro-collapsible-section-card
  class="migrations-select-pbx-container"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
  [title]="
    formData?.pbxType && formData?.pbxType !== AssessmentPbxType.CISCO
      ? 'tkey;migrations.create.ring_central.card.title'
      : formData?.pbxType && 'tkey;migrations.create.pbx_type.cisco'
  "
>
  <ziro-text fieldId="name"></ziro-text>
  <ziro-radio fieldId="pbxType"></ziro-radio>
  <div [hidden]="formData?.pbxType !== AssessmentPbxType.RING_CENTRAL">
    <div
      class="alert alert-info ring-central-card__alert"
      [innerHTML]="'tkey;migrations.create.ring_central.card.alert' | escapeHtml"
    ></div>
    <ziro-text fieldId="ringCentralClientId"></ziro-text>
    <ziro-text fieldId="ringCentralClientSecret"></ziro-text>
    <ziro-text fieldId="ringCentralJwtToken"></ziro-text>
  </div>
</ziro-collapsible-section-card>
<div
  [hidden]="formData?.pbxType !== AssessmentPbxType.CISCO"
  [class]="'list-group list-group-striped border-rad-all-12 card-shadow'"
>
  <div class="list-group-item">
    <ziro-file-upload-box fieldId="ciscoTar" cardClasses="border-0"></ziro-file-upload-box>
  </div>
  <div class="list-group-item">
    <ziro-file-upload-box fieldId="ciscoCdr" cardClasses="border-0 bg-transparent"></ziro-file-upload-box>
  </div>
  <div class="list-group-item">
    <ziro-file-upload-box fieldId="ciscoUnity" cardClasses="border-0"></ziro-file-upload-box>
  </div>
</div>

<!--  Hidden temporarily @  #22452-->
<ziro-file-upload-box fieldId="ciscoCer" hidden cardClasses="border-0 bg-transparent"></ziro-file-upload-box>
